// extracted by extract-css-chunks-webpack-plugin
module.exports = {"activeCartReminder":"MDH5S","tooltipContent":"WssAX","activeCartBtn":"REqKD","saveTooltipBottom":"jGgEn"};